/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Data_Processing_Item_AiInputs */

const en_privacy_data_processing_item_ai = /** @type {(inputs: Privacy_Data_Processing_Item_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI interaction data:`)
};

const de_privacy_data_processing_item_ai = /** @type {(inputs: Privacy_Data_Processing_Item_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Interaktionsdaten:`)
};

const fr_privacy_data_processing_item_ai = /** @type {(inputs: Privacy_Data_Processing_Item_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données d'interaction IA :`)
};

const es_privacy_data_processing_item_ai = /** @type {(inputs: Privacy_Data_Processing_Item_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de interacción con IA:`)
};

const it_privacy_data_processing_item_ai = /** @type {(inputs: Privacy_Data_Processing_Item_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati di interazione AI:`)
};

const nl_privacy_data_processing_item_ai = /** @type {(inputs: Privacy_Data_Processing_Item_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-interactiegegevens:`)
};

const pl_privacy_data_processing_item_ai = /** @type {(inputs: Privacy_Data_Processing_Item_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane interakcji z AI:`)
};

const fi_privacy_data_processing_item_ai = /** @type {(inputs: Privacy_Data_Processing_Item_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tekoälyn vuorovaikutustiedot:`)
};

const da_privacy_data_processing_item_ai = /** @type {(inputs: Privacy_Data_Processing_Item_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-interaktionsdata:`)
};

const sv_privacy_data_processing_item_ai = /** @type {(inputs: Privacy_Data_Processing_Item_AiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-interaktionsdata:`)
};

/**
* | output |
* | --- |
* | "AI interaction data:" |
*
* @param {Privacy_Data_Processing_Item_AiInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_data_processing_item_ai = /** @type {((inputs?: Privacy_Data_Processing_Item_AiInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Data_Processing_Item_AiInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_data_processing_item_ai(inputs)
	if (locale === "fr") return fr_privacy_data_processing_item_ai(inputs)
	if (locale === "es") return es_privacy_data_processing_item_ai(inputs)
	if (locale === "it") return it_privacy_data_processing_item_ai(inputs)
	if (locale === "nl") return nl_privacy_data_processing_item_ai(inputs)
	if (locale === "pl") return pl_privacy_data_processing_item_ai(inputs)
	if (locale === "fi") return fi_privacy_data_processing_item_ai(inputs)
	if (locale === "da") return da_privacy_data_processing_item_ai(inputs)
	if (locale === "sv") return sv_privacy_data_processing_item_ai(inputs)
	return en_privacy_data_processing_item_ai(inputs)
});